/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Information for connecting to our authentication provider
 */
export type Auth0Config = {
  /**
   * The audience of the Auth0 application
   */
  audience: string;
  /**
   * The client ID of the Auth0 application
   */
  clientId: string;
  /**
   * The domain of the Auth0 tenant
   */
  domain: string;
};

/** @internal */
export const Auth0Config$inboundSchema: z.ZodType<
  Auth0Config,
  z.ZodTypeDef,
  unknown
> = z.object({
  audience: types.string(),
  client_id: types.string(),
  domain: types.string(),
}).transform((v) => {
  return remap$(v, {
    "client_id": "clientId",
  });
});

export function auth0ConfigFromJSON(
  jsonString: string,
): SafeParseResult<Auth0Config, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Auth0Config$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Auth0Config' from JSON`,
  );
}
